const logger = (...messages: any[]) => {
  return process.env.REACT_APP_NODE_ENV === "development"
    ? console.log(...messages) // eslint-disable-line no-console
    : null;
};

export default logger;
